import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";
import { IBriefProduct } from "../../../../../types/product/ibrief-product/ibrief-product.interface";

export enum CampaignBriefProductsActions {
  AddProduct = "CampaignBriefProducts/AddProduct",
  AddProductFailure = "CampaignBriefProducts/AddProductFailure",
  AddProductSuccess = "CampaignBriefProducts/AddProductSuccess",

  FetchProducts = "CampaignBriefProducts/FetchProducts",
  FetchProductsFailure = "CampaignBriefProducts/FetchProductsFailure",
  FetchProductsSuccess = "CampaignBriefProducts/FetchProductsSuccess",

  Reset = "CampaignBriefProducts/Reset",

  UpdateProducts = "CampaignBriefProducts/UpdateProducts",
  UpdateProductsFailure = "CampaignBriefProducts/UpdateProductsFailure",
  UpdateProductsSuccess = "CampaignBriefProducts/UpdateProductsSuccess",
}

export const addProduct = (product: number, CampaignBriefId: number) =>
  action(CampaignBriefProductsActions.AddProduct, { product, CampaignBriefId });
export const addProductFailure = (error: IError) =>
  action(CampaignBriefProductsActions.AddProductFailure, error);
export const addProductSuccess = (product: IBriefProduct) =>
  action(CampaignBriefProductsActions.AddProductSuccess, product);

export const fetchProducts = (CampaignBriefId: number) =>
  action(CampaignBriefProductsActions.FetchProducts, { CampaignBriefId });
export const fetchProductsFailure = (error: IError) =>
  action(CampaignBriefProductsActions.FetchProductsFailure, error);
export const fetchProductsSuccess = (products: IBriefProduct[]) =>
  action(CampaignBriefProductsActions.FetchProductsSuccess, products);

export const reset = () => action(CampaignBriefProductsActions.Reset);

export const updateProducts = (products: BriefProductForm[], CampaignBriefId: number) =>
  action(CampaignBriefProductsActions.UpdateProducts, { products, CampaignBriefId });
export const updateProductsFailure = (error: IError) =>
  action(CampaignBriefProductsActions.UpdateProductsFailure, error);
export const updateProductsSuccess = (products: IBriefProduct[]) =>
  action(CampaignBriefProductsActions.UpdateProductsSuccess, products);

const actionCreators = {
  addProduct,
  addProductFailure,
  addProductSuccess,

  fetchProducts,
  fetchProductsFailure,
  fetchProductsSuccess,

  reset,

  updateProducts,
  updateProductsSuccess,
  updateProductsFailure,
};

export type CampaignBriefProductsActionType = ActionType<typeof actionCreators>;
